import { ChangeDetectionStrategy, Component, computed, HostBinding, input, ViewEncapsulation } from '@angular/core';
import { Tag, TagModule } from 'primeng/tag';
import { TagSeverity } from './contract/tag-severity.contract';

@Component({
  selector: 'osp-tag',
  standalone: true,
  imports: [TagModule],
  templateUrl: './tag.component.html',
  styleUrl: './tag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TagComponent {
  @HostBinding('class') protected hostClass = 'osp-tag';

  severity = input<TagSeverity>();
  rounded = input(false);
  value = input<string>();
  border = input(false);
  icon = input<string>();

  protected $adaptedSeverity = computed<Tag['severity']>(() => <Tag['severity']>this.severity());

  styleClass = computed(() => (this.border() ? 'tag-bordered' : ''));
}
